module.exports = __webpack_public_path__ + "img/QHP.dfc06bad.jpg";